module.exports = __webpack_public_path__ + "assets/img/register-thankyou.31b30361.jpg";